module.exports = __webpack_public_path__ + "static/classeditor-fb0263200181d55e2cff0758e74fd2f5.png";